module.exports = {
  1: 19169070,
  17000: 882795,
  11155111: 5225823,
}
